import React, { memo } from 'react';
// import PropTypes from 'prop-types';

import Card from './reportCardWithRisk';

function SubSectionContainer({ children, ...rest }) {
  return (
    <div className="complexity-section-card-wrapper">
      <Card containerClassName="complexity-section-card-header" {...rest} />
      {React.Children.map(children, (node) =>
        React.cloneElement(node, { noHeader: true }),
      )}
    </div>
  );
}

SubSectionContainer.propTypes = {};

export default memo(SubSectionContainer);
